export default {};
throw new Error(`Could not resolve "three" imported by "@appletosolutions/reactbits". Is it installed?`)